import { render } from "./SystemHomeSections.vue?vue&type=template&id=0d2c6d1d&scoped=true"
import script from "./SystemHomeSections.vue?vue&type=script&lang=js"
export * from "./SystemHomeSections.vue?vue&type=script&lang=js"

import "./SystemHomeSections.vue?vue&type=style&index=0&id=0d2c6d1d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2c6d1d"]])

export default __exports__